/**
 * Constants for Coupon Codes component
 */

// Mapping of field names to their translation keys
export const FIELD_NAME_TO_TRANSLATION_KEY = {
  couponCode: 'FIELDS.COUPON_CODE',
  dollarValue: 'FIELDS.DOLLAR_VALUE',
  duration: 'FIELDS.DURATION',
  startDate: 'FIELDS.START_DATE',
  expireDate: 'FIELDS.EXPIRE_DATE',
  createdAt: 'FIELDS.CREATED_AT',
  couponType: 'FIELDS.COUPON_TYPE',
  customerSegment: 'FIELDS.CUSTOMER_SEGMENT',
  contractTerm: 'FIELDS.CONTRACT_TERM',
  businessConnectEdition: 'FIELDS.BUSINESS_CONNECT_EDITION',
  doesTheCustomerRequireWhiteGlove: 'FIELDS.WHITE_GLOVE_REQUIRED',
  typeOfInstallation: 'FIELDS.INSTALLATION_TYPE',
  provinceOfTheOrder: 'FIELDS.PROVINCE',
  multisiteOrder: 'FIELDS.MULTISITE_ORDER',
  otherTelusServices: 'FIELDS.OTHER_TELUS_SERVICES',
  minimumSeats: 'FIELDS.MINIMUM_SEATS',
  channel: 'FIELDS.CHANNEL',
  dealership: 'FIELDS.DEALERSHIP',
  descriptionEn: 'FIELDS.DESCRIPTION_EN',
  descriptionFr: 'FIELDS.DESCRIPTION_FR',
  socStarterEn: 'FIELDS.SOC_STARTER_EN',
  socStarterFr: 'FIELDS.SOC_STARTER_FR',
  socOfficeEn: 'FIELDS.SOC_OFFICE_EN',
  socOfficeFr: 'FIELDS.SOC_OFFICE_FR',
  commentInContract: 'FIELDS.COMMENT_IN_CONTRACT'
};

// Field categories for organizing fields in the modal
export const FIELD_CATEGORIES = {
  coupon: {
    titleKey: 'COUPON_DETAILS',
    fields: ['couponCode', 'dollarValue', 'duration', 'startDate', 'expireDate', 'createdAt']
  },
  selection: {
    titleKey: 'CONFIGURATION_FIELDS',
    fields: ['couponType', 'customerSegment', 'contractTerm', 'businessConnectEdition', 'doesTheCustomerRequireWhiteGlove', 'typeOfInstallation', 'provinceOfTheOrder', 'multisiteOrder', 'otherTelusServices', 'minimumSeats', 'channel', 'dealership']
  },
  bilingual: {
    titleKey: 'BILINGUAL_CONTENT',
    fields: ['descriptionEn', 'descriptionFr', 'socStarterEn', 'socStarterFr', 'socOfficeEn', 'socOfficeFr']
  },
  contract: {
    titleKey: 'CONTRACT_DETAILS',
    fields: ['commentInContract']
  }
};

// Bilingual fields that store values in "English, French" format
export const BILINGUAL_FIELDS = [
  'customerSegment', 'contractTerm', 'businessConnectEdition',
  'doesTheCustomerRequireWhiteGlove', 'typeOfInstallation', 'provinceOfTheOrder',
  'multisiteOrder', 'otherTelusServices', 'duration', 'couponType'
];
